import Warning from "@material-symbols/svg-500/rounded/warning.svg?react";
import { memo } from "react";

import { IconCreator } from "./_utils/icon-creator";

import type { SVGIconProps } from "./_utils/icon-creator";

const WarningInfoIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: Warning });
	return <Icon />;
};

export default memo(WarningInfoIcon);
